export const GlobalVariable = Object.freeze({
    PAGE_TITLE_BASE: 'ABMP CE',
});